import { render, staticRenderFns } from "./ToReceive.vue?vue&type=template&id=8fa5ba98&"
import script from "./ToReceive.vue?vue&type=script&lang=js&"
export * from "./ToReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports